import React from 'react';
import { Link } from 'react-router-dom';
import Logo from '../../assets/images/Logo.png';

const socials = [
  {
    label: 'Facebook',
    href: 'https://www.facebook.com/fsel.official',
    icon: (
      <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
        <path d="M18 2h-3a5 5 0 00-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 011-1h3z"/>
      </svg>
    ),
  },
  {
    label: 'LinkedIn',
    href: 'https://www.linkedin.com/company/foundationsolarenergy/',
    icon: (
      <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
        <path d="M16 8a6 6 0 016 6v7h-4v-7a2 2 0 00-2-2 2 2 0 00-2 2v7h-4v-7a6 6 0 016-6zM2 9h4v12H2z"/>
        <circle cx="4" cy="4" r="2"/>
      </svg>
    ),
  },
  {
    label: 'YouTube',
    href: 'https://www.youtube.com/@FSEL.Official',
    icon: (
      <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
        <path d="M22.54 6.42a2.78 2.78 0 00-1.95-1.96C18.88 4 12 4 12 4s-6.88 0-8.59.46A2.78 2.78 0 001.46 6.42 29 29 0 001 12a29 29 0 00.46 5.58 2.78 2.78 0 001.95 1.96C5.12 20 12 20 12 20s6.88 0 8.59-.46a2.78 2.78 0 001.95-1.96A29 29 0 0023 12a29 29 0 00-.46-5.58z"/>
        <polygon points="9.75 15.02 15.5 12 9.75 8.98 9.75 15.02" fill="white"/>
      </svg>
    ),
  },
  {
    label: 'Instagram',
    href: 'https://www.instagram.com/fsel.official',
    icon: (
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <rect x="2" y="2" width="20" height="20" rx="5" ry="5"/>
        <circle cx="12" cy="12" r="4"/>
        <circle cx="17.5" cy="6.5" r="0.5" fill="currentColor" stroke="none"/>
      </svg>
    ),
  },
];

const navLinks = [
  { label: 'Home',       to: '/' },
  { label: 'Governance', to: '/bod' },
  { label: 'Services',   to: '/services' },
  { label: 'Portfolio',  to: '/portfolio' },
  { label: 'Contact Us', to: '/contact' },
  { label: 'About Us',   to: '/about' },
];

function Footer() {
  return (
    <footer style={{ backgroundColor: '#0a1f44' }} className="text-white">

      {/* main content */}
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-14 grid grid-cols-1 md:grid-cols-3 gap-12">

        <div className="flex flex-col gap-6">
          <img src={Logo} alt="FSEL Logo" className="h-14 w-auto max-w-[60px] object-contain" />
          <p className="text-white/60 text-sm leading-relaxed max-w-xs">
            Foundation Solar Energy Limited — Pakistan's leading EPC solar company delivering sustainable energy since 2019.
          </p>
          <div className="flex items-center gap-3">
            {socials.map((s) => (
              <a
                key={s.label}
                href={s.href}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={s.label}
                className="flex items-center justify-center w-9 h-9 rounded-full border border-white/20 text-white/60 hover:text-white hover:border-yellow-400 hover:bg-yellow-400/10 transition-all duration-200"
              >
                {s.icon}
              </a>
            ))}
          </div>
        </div>

        <div>
          <h4 className="font-semibold text-white text-sm uppercase tracking-widest mb-5">
            Quick Links
          </h4>
          <ul className="space-y-3">
            {navLinks.map(({ label, to }) => (
              <li key={label}>
                <Link
                  to={to}
                  className="text-white/60 hover:text-yellow-400 transition-colors duration-200 text-sm flex items-center gap-2 group"
                >
                  <span className="w-0 group-hover:w-3 h-px bg-yellow-400 transition-all duration-300 inline-block"></span>
                  {label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="font-semibold text-white text-sm uppercase tracking-widest mb-5">
            Contact Us
          </h4>
          <ul className="space-y-4 text-sm">

            <li className="flex items-start gap-3">
              <svg className="w-4 h-4 text-yellow-400 mt-0.5 flex-shrink-0" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                <path d="M21 10c0 7-9 13-9 13S3 17 3 10a9 9 0 0118 0z"/>
                <circle cx="12" cy="10" r="3"/>
              </svg>
              <span className="text-white/70 leading-relaxed">
                1st Floor, Al Ghani Arcade,<br />
                GT Road, Rawalpindi
              </span>
            </li>

            <li className="flex items-center gap-3">
              <svg className="w-4 h-4 text-yellow-400 flex-shrink-0" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                <path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07A19.5 19.5 0 013.07 9.81a19.79 19.79 0 01-3.07-8.67A2 2 0 012 .18h3a2 2 0 012 1.72 12.84 12.84 0 00.7 2.81 2 2 0 01-.45 2.11L6.09 7.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45 12.84 12.84 0 002.81.7A2 2 0 0122 14z"/>
              </svg>
              <div className="space-y-1">
                <a href="tel:051111113735" className="block text-white/70 hover:text-yellow-400 transition-colors duration-200">
                  UAN: 051 111-113-735
                </a>
                <a href="tel:05147209068" className="block text-white/70 hover:text-yellow-400 transition-colors duration-200 mt-1">
                  051 4720906 8
                </a>
                <span className="block text-white/40 text-xs mt-1">Fax: 051 4720908</span>
              </div>
            </li>

            <li className="flex items-center gap-3">
              <svg className="w-4 h-4 text-yellow-400 flex-shrink-0" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
                <polyline points="22,6 12,13 2,6"/>
              </svg>
              <a
                href="mailto:contact@fsel.fonpv.org"
                className="text-white/70 hover:text-yellow-400 transition-colors duration-200"
              >
                contact@fsel.fonpv.org
              </a>
            </li>

          </ul>
        </div>

      </div>

      {/* bottom bar */}
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-white/40 text-xs">
            &copy; 2026 Foundation Solar Energy Limited. All rights reserved.
          </p>
          <p className="text-white/40 text-xs">
            Part of the Fauji Foundation Group
          </p>
        </div>
      </div>

    </footer>
  );
}

export default Footer;